import React, { useRef, useState } from 'react'
import './Contact.css'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { toast } from 'react-toastify'
import emailjs from '@emailjs/browser';


const Contact = () => {
  const [fName,setFName] = useState('');
  const [lName,setLName] = useState('');
  const [email,setEmail] = useState('');
  const [message,setMessage] = useState('');
  const [loader,setLoader] = useState(false);
  const form  = useRef();
  const sendMail=(e)=>{
    e.preventDefault();
    if(fName==='' || lName==='' || email==='' || message==='' ){
      toast.warn('All Fields are Mandatory');
    }
    else{
      if(email.includes('.com') && email.includes('@')){
        setLoader(true);
        emailjs.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, {
          user_name:`${fName} ${lName}`,
          user_email:email,
          message
        },process.env.REACT_APP_PUBLIC_KEY)
        .then(function(response) {
          if(response.text === "OK"){toast.success("Email Sent Successfully.");setLoader(false)};
        }, function(error) {
          toast.warn(error.message);
          setLoader(false);
        });
      }
      else{
        toast.warn('Invalid Email');
      }
    }
  }
  return (
    <>
    <Header/>
    <div className="contact">
        <div className="banner">
            <h3>Drop a query</h3>
            <p>Send us a Message, drop a line and we will reply you back shortly.</p>
        </div>
        <div className="box">
          {
            (loader)? <div className="loader"><div className="spin"></div></div>:
            <form ref={form} method='#' onSubmit={(e)=>sendMail(e)}>
                <input onChange={(e)=>setFName(e.currentTarget.value)} name='user_name' type="text" placeholder='First Name' />
                <input onChange={(e)=>setLName(e.currentTarget.value)} type="text" placeholder='Last Name' />
                <input onChange={(e)=>setEmail(e.currentTarget.value)} name='user_email' type="email" placeholder='Email' />
                <textarea onChange={(e)=>setMessage(e.currentTarget.value)} name='message' placeholder='Message' ></textarea>
                <input type="submit" value={'Send'} />
            </form>
          }
            <div className="map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6995.9569707812425!2d77.11047831091032!3d28.750059308282555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0138a74f7da7%3A0xf09fad683c23bd5d!2sDelhi%20Technological%20University!5e0!3m2!1sen!2sin!4v1690286657233!5m2!1sen!2sin"></iframe>
            </div>
        </div>
    </div>
    <Footer/>
    </>
  )
}

export default Contact